






























































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-syntax */
import { Component, Vue, Watch } from 'vue-property-decorator';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ChevronIcon from 'mdi-vue/ChevronRight';
import CloseIcon from 'mdi-vue/Close';
import Checkbox from '@/components/Checkbox.vue';
import api, { apiSandbox } from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import Modal from '@/components/Modal.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import auth from '@/libs/auth';
import ModalContent from './modal.vue';

@Component({
  components: {
    Button,
    LayoutContent,
    LayoutTitle,
    Loader,
    StatusIndicator,
    Pagination,
    CloseIcon,
    ChevronIcon,
    Checkbox,
    Modal,
    ModalContent,
  },
})
export default class UserList extends Vue {
  loading = true;
  qris = false;
  listItem: any[] = [];
  showModal = false;
  checked: any = {};
  allSelected: any = [];
  pcKeys: any = [];
  expand: any = [];
  url = process.env.VUE_APP_API_URL;
  merchantCode = '';
  fdsParams: any = {}
  data: any = [];
  loadingSubmit = false
  isProduction = false;
  user!: {
    user: User;
  };

  // @Watch('allSelected')
  // gas() {
  //   this.check();
  //   console.log(this.checked);
  // }

  // @Watch('checked')
  // gas2() {
  //   this.check();
  //   console.log(this.checked);
  // }

  // async check() {
  //   setTimeout(() => {
  //     for (const [key, value] of Object.entries(this.checked)) {
  //       // console.log(`${key}: ${value}`);
  //       if (value === true) {
  //         if (this.data.find((e: any) => e === key)) {
  //           // this.data.splice(this.data.indexOf(key));
  //           // console.log('match');
  //         } else {
  //           this.data.push(key);
  //         }
  //       } else if (value === false) {
  //         this.data.splice(this.data.indexOf(key));
  //       } else {
  //         console.log('loh');
  //       }
  //     }
  //     console.log(this.data);
  //   }, 100);
  // }

  checkedChange() {
    this.pcKeys.forEach((pcKey: any) => {
      let checkedAll = true;
      this.listItem[pcKey]
        .map((a: any) => a.service_code)
        .forEach((b: any) => {
          const bNumber = parseInt(b, 10);
          if (this.checked[bNumber].value === undefined || this.checked[bNumber].value === false) {
            checkedAll = false;
          }
        });
      this.allSelected[this.pcKeys.indexOf(pcKey)] = checkedAll;
    });
    // console.log(this.checked.map((e: any) => ({})));
    // console.log([Object.keys(this.checked)]);
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  close(value: any) {
    this.showModal = value;
  }

  fds(value: any) {
    this.fdsParams = value;
  }

  async mounted() {
    if (process.env.VUE_APP_ENVIRONMENT === 'production') {
      this.isProduction = true;

      if (this.user.user.merchant.status === 'INACTIVE') {
        this.$router.replace('/dashboard');
      }
    }

    this.merchantCode = JSON.parse(localStorage.getItem('USER') || '{}').user.merchant.merchant_code;
    await this.getList();
    await this.getListChecked();
    await this.checkQris();
  }

  toggleExpand(val: any) {
    // this.expand[val] = !this.expand[val];
    this.expand.splice(1);
    this.expand.push(this.expand[val] = !this.expand[val]);
  }

  selectAllChange(indexAll: number) {
    const value = this.allSelected[indexAll];
    if (value) {
      this.listItem[this.pcKeys[indexAll]]
        .forEach((d: any) => {
          if ((d.service_code !== '1089') || (d.service_code === '1089' && this.qris)) {
            this.checked[d.service_code].value = true;
          }
        });
    } else {
      this.listItem[this.pcKeys[indexAll]]
        .forEach((d: any) => {
          if (!this.checked[d.service_code].isDisabled) {
            this.checked[d.service_code].value = false;
          }
        });
    }
  }

  async updateFds(channelId: any) {
    Object.assign(this.fdsParams, { channel_id: channelId });
    await apiSandbox.put('fds', this.fdsParams);
  }

  async AddpaymentChannel() {
    try {
      this.loadingSubmit = true;
      const ps: string[] = [];
      Object.entries(this.checked).forEach((a: any) => {
        const [sc, v] = a;
        if (v.value && !v.isDisabled) {
          ps.push(sc);
        }
      });
      const { data } = await apiSandbox.post('merchant/payment-channel', {
        service_code: ps,
      });
      this.loadingSubmit = false;
      data.success.forEach((e: any) => {
        if (e.service_code === '2002') {
          this.updateFds(e.channel_id);
        }
      });
      showToast(
        ToastType.SUCCESS,
        'Success',
        data.messsage,
      );
      window.setTimeout(() => {
        auth.filterPermissionService();
        this.$router.push('/integration');
      }, 300);
    } catch (err) {
      this.loadingSubmit = false;
      showToast(
        ToastType.FAILED,
        'Oops… Sorry',
        err.response.data.messsage,
      );
      if (err.response.data.success.length > 0) {
        err.response.data.success.forEach((e: any) => {
          if (e.service_code === '2002') {
            this.updateFds(e.channel_id);
          }
        });
        window.setTimeout(() => {
          this.$router.push('/integration');
        }, 300);
      }
    }
  }

  async getList() {
    try {
      this.loading = true;
      const { data } = await api.get('listPaymentChannel');
      const abc: any = {};
      const sortedPCKeys = Object.keys(data);
      console.log(sortedPCKeys);
      sortedPCKeys.forEach((e: any) => {
        abc[e] = data[e];
        abc[e].forEach((val: any) => {
          Vue.set(this.checked, val.service_code, { value: false, isDisabled: false });
        });
      });
      this.listItem = abc;
      this.pcKeys = sortedPCKeys;
      this.loading = false;
    } catch (err) {
      console.error(err);
      this.loading = false;
    }
  }

  async checkQris() {
    try {
      this.loading = true;
      await api.get('checkQris');
      this.qris = true;
      this.loading = false;
    } catch (err) {
      console.error(err);
      this.qris = false;
      this.loading = false;
    }
  }

  async getListChecked() {
    try {
      this.loading = true;
      const { data } = await apiSandbox.get('paymentChannel');
      data.forEach((val: any) => {
        this.checked[val] = {
          value: true,
          isDisabled: true,
        };
      });
      this.checkedChange();
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  }

  tooltipLink(channel: string) {
    if (channel === 'onepay') {
      window.open('https://pgbayarind.id/Produk/One-Pay', '_blank');
    } else {
      window.open('https://pgbayarind.id/Produk/Easy-Invoice', '_blank');
    }
  }
}
